import React from "react";
import "../../People.css";
import "../../assets/css/people.css";
import studentData from "../../data/students.json";

const PhDStudents = () => {
  const phdStudents = studentData.students["PhD"] || [];

  return (
    <div className="people-container">
      {/* PhD Students Section */}
      <div id="phd-students" className="students-section">
        <h1 className="section-heading">PhD Students</h1>
        <div>
           <div className="students-grid">
              {phdStudents.map((student, index) => (
                <div className="student-member" key={index}>
                  <h3 className="team-name">{student.name}</h3>
                  <p className="team-designation">{student.rollNo}</p>
                </div>
              ))}
           </div>
        </div>
      </div>
    </div>
  );
};

export default PhDStudents;
